import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bs-middle-menu-element',
  templateUrl: './middle-menu-element.component.html',
  styleUrls: ['./middle-menu-element.component.css']
})
export class MiddleMenuElementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
